export function isMobile() {
  return globalThis.innerWidth < 640;
}

export function isLaptopOrLarger() {
  return globalThis.innerWidth >= 1024;
}
